import { render, staticRenderFns } from "./ClassroomList.vue?vue&type=template&id=08b65ad9&"
import script from "./ClassroomList.vue?vue&type=script&lang=js&"
export * from "./ClassroomList.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports